<script>
  // Перенос BuyBtn из pass.tsx.
  // ⚠️ Цена показывается ВСЕГДА, в том числе когда не хватает JC: раньше кнопка
  // при нехватке заменялась на «Не хватает JC» без числа, и во вкладках
  // «Наборы / Услуги / Премиум / Валюта» (там цена больше нигде не выводится)
  // человек не видел цену, пока не накопит нужную сумму.
  import { t } from '../../i18n.js';
  import GoldBtn from './goldbtn.svelte';
  import GhostBtn from './ghostbtn.svelte';
  import Jc from './jc.svelte';
  export let price = 0;
  export let balance = 0;
  export let label = null;      // «Обменять» и т.п.; по умолчанию «Купить»
  export let onBuy = () => {};
</script>

{#if balance < price}
  <GhostBtn block size="sm" disabled style="opacity:0.55;cursor:default">{t('m.notEnough')} · <Jc v={price} /></GhostBtn>
{:else}
  <GoldBtn block size="sm" on:click={onBuy}>{label || t('m.buy')} · <Jc v={price} /></GoldBtn>
{/if}
